import { Rule, AtRule, Declaration } from 'postcss'

export type DeclarationsMap = Map<Declaration['prop'], Declaration['value']>

export class ListMap<T> {
	map: Map<string, Array<T>> = new Map()

	add(key: string, item: any) {
		if (!this.map.has(key)) {
			this.map.set(key, [])
		}

		this.map.set(key, [...this.map.get(key)!, item])
	}

	iterateDuplicates(cb: (items: Array<T>, key: string) => void) {
		this.map.forEach((items, key) => {
			if (items.length > 1) {
				cb(items, key)
			}
		})
	}

	get hasDuplicates() {
		return [...this.map].some(([_, items]) => items.length > 1)
	}
}

export const getDeclarationNodes = (r: Rule): Array<Declaration> =>
	// @ts-expect-error
	r.nodes.filter((node) => node.type === 'decl')

export const isMediaRule = (r: Rule) => r.parent?.type === 'atrule' && (r.parent as AtRule).name === 'media'

export const isVariableDeclarationRule = (r: Rule) => getDeclarationNodes(r).every((d) => d.prop.startsWith('--'))

export const buildRootRulesDeclarations = (rules: Array<Rule>) =>
	rules.reduce((declarations, rule) => {
		if (!isMediaRule(rule)) {
			getDeclarationNodes(rule).forEach((d) => {
				declarations.set(d.prop, d.value)
			})
		}

		return declarations
	}, new Map<Declaration['prop'], Declaration['value']>())
